import {
  Column,
  ColumnDirective,
  ColumnMenu,
  ColumnsDirective,
  Edit,
  EditSettingsModel,
  Filter,
  FilterSettingsModel,
  GridComponent,
  Inject,
  Page,
  PageSettingsModel,
  Resize,
  Toolbar,
} from '@syncfusion/ej2-react-grids';
import { ColorPickerComponent, TextBoxComponent } from '@syncfusion/ej2-react-inputs';
import { ButtonPropsModel, DialogComponent } from '@syncfusion/ej2-react-popups';
import React, { Component } from 'react';

interface IState {
  hideAddDialog: boolean;
  hideEditDialog: boolean;
  hideDeleteDialog: boolean;
  elementAliasData:Array<any>
}
interface IProps {}
export class SystemConfigration extends Component<IProps, IState> {
  private buttonForAdd: ButtonPropsModel[];
  private buttonForEdit: ButtonPropsModel[];
  private buttonForDelete: ButtonPropsModel[];
  private elementAliasGrid: GridComponent;
  constructor(prop: IProps) {
    super(prop);
    this.state = {
      hideAddDialog: false,
      hideDeleteDialog: false,
      hideEditDialog: false,
      elementAliasData:[]
    };
    this.buttonForAdd = [
      {
        click: () => {
          this.addElementAlias();
        },
        buttonModel: {
          content: 'Save',
          isPrimary: true,
        },
      },
      {
        click: () => {
          this.setState({ hideAddDialog: false });
        },
        buttonModel: {
          content: 'Cancel',
          isPrimary: false,
        },
      },
    ];
    this.buttonForEdit = [
      {
        click: () => {
          this.editElementAlias();
        },
        buttonModel: {
          content: 'Save',
          isPrimary: true,
        },
      },
      {
        click: () => {
          this.setState({ hideEditDialog: false });
        },
        buttonModel: {
          content: 'Cancel',
          isPrimary: false,
        },
      },
    ];
    this.buttonForDelete = [
      {
        click: () => {
          this.deleteElementAlias();
        },
        buttonModel: {
          content: 'Yes',
          isPrimary: true,
        },
      },
      {
        click: () => {
          this.setState({ hideDeleteDialog: false });
        },
        buttonModel: {
          content: 'No',
        },
      },
    ];
    this.elementAliasGrid=new GridComponent(prop);
  }
  public FilterOptions: FilterSettingsModel = { type: 'Menu' };
  public toolbarOptions = [
    {
      text: 'Add',
      tooltipText: 'Add',
      prefixIcon: 'e-add',
      id: 'add',
    },
    {
      text: 'Edit',
      tooltipText: 'Edit',
      prefixIcon: 'e-edit',
      id: 'edit',
    },
    {
      text: 'Delete',
      tooltipText: 'Delete',
      prefixIcon: 'e-delete',
      id: 'delete',
    },
  ];
  public editOptions: EditSettingsModel = {
    allowAdding: false,
    allowDeleting: false,
    allowEditing: false,
    allowEditOnDblClick: false,
    showConfirmDialog: false,
    showDeleteConfirmDialog: false,
  };
  public pageOptions: PageSettingsModel = {
    currentPage: 1,
    pageSize: 12,
    pageCount: 8,
    pageSizes: true,
  };
  toolbarClick(args: any) {
    if (args.item.id === 'add') {
      this.setState({ hideAddDialog: true });
    }
    if (args.item.id === 'delete') {
      
    }
    if (args.item.id === 'edit') {
     
    }
  }
  deleteElementAlias() {
    throw new Error('Method not implemented.');
  }
  editElementAlias() {
    throw new Error('Method not implemented.');
  }
  addElementAlias() {
    throw new Error('Method not implemented.');
  }
  render() {
    return (
      <div>
      
      </div>
    );
  }
}

export default SystemConfigration;
